import React from 'react';
import useGetProgramStores from 'src/store/hooks/useGetProgramStoresResult';
import BaseSelector, { Option } from './BaseSelector';

interface StoreSelectorProps {
  selectedStoreId?: string;
  onStoreSelect: (storeId: string) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
}

/**
 * Basic component to handle store selection
 */
const StoreSelector: React.FC<StoreSelectorProps> = ({
  selectedStoreId,
  onStoreSelect,
  placeholder = 'Select a store',
  label = 'Store',
  disabled = false,
}) => {
  // Get Stores for program
  const stores: Option[] = useGetProgramStores().map((s) => ({
    value: s.store,
    label: s.label,
  }));

  return (
    <BaseSelector<Option>
      label={label}
      placeholder={placeholder}
      options={stores}
      value={selectedStoreId}
      onChange={onStoreSelect}
      disabled={disabled}
    />
  );
};

export default StoreSelector;
